import { PageHeader, PanelCard } from '../../school_panel/components/ui';
import SetupChecklist from './SetupChecklist';

export default function SetupGuide() {
  return (
    <div>
      <PageHeader eyebrow="School setup" title="Set up your school" subtitle="Work through the steps in order; each one opens the page where it's done." />
      <PanelCard className="max-w-[720px]"><SetupChecklist /></PanelCard>
    </div>
  );
}
